import { Box, Typography } from "@material-ui/core";
import { TaskAltRounded } from "@mui/icons-material";
import {
  Grid,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  styled,
} from "@mui/material";
import React from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";

import { imagesList } from "../../../constants";
import { primary } from "../../../constants/theme";

const CustomBenefits = styled(Box)(({ theme }) => ({
  background: "#403E89",
  padding: "104px 47px 139px 142px",
  //marginBottom: "100px",
  color: primary.white,
  ".benefits-heading": {
    fontWeight: "900",
    fontSize: "54px",
    lineHeight: "106px",
  },
  ".benefit span": {
    fontWeight: "400",
    fontSize: "32px",
    lineHeight: "44px",
  },
  ".avatar-benefit-list svg": {
    color: "#87F4A6",
  },
  ".avatar-benefit-list": {
    minWidth: "44px",
  },
  [theme.breakpoints.down("md")]: {
    padding: "16px",
    margin: "24px 0px",
    ".benefits-heading": {
      fontSize: "24px",
      lineHeight: "30px",
    },
    ".benefit span": {
      fontSize: "14px",
      lineHeight: "16px",
    },
    ".avatar-benefit-list": {
      minWidth: "34px",
    },
    ".benefits-list": {
      paddingLeft: "unset",
    },
    ".avatar-benefit-list svg": {
      fontSize: "1.2rem",
    },
    ".benefit": {
      marginTop: "unset",
    },
  },
}));

const LeadCaptureBenefits = () => {
  return (
    <CustomBenefits>
      <Grid
        container
        spacing={2}
        sx={{ alignItems: "end", marginBottom: "0px" }}
      >
        <Grid sx={{ display: "block" }} item xs={12} md={6}>
          <Typography className="benefits-heading">
            Book online to get{" "}
          </Typography>
          <List>
            <ListItem className="benefits-list">
              <ListItemAvatar className="avatar-benefit-list">
                <TaskAltRounded />
              </ListItemAvatar>
              <ListItemText
                className="benefit"
                primary={"low processing fees"}
              />
            </ListItem>
            <ListItem className="benefits-list">
              <ListItemAvatar className="avatar-benefit-list">
                <TaskAltRounded />
              </ListItemAvatar>
              <ListItemText
                className="benefit"
                primary={"Lowest Interest rates"}
              />
            </ListItem>
            <ListItem className="benefits-list">
              <ListItemAvatar className="avatar-benefit-list">
                <TaskAltRounded />
              </ListItemAvatar>
              <ListItemText
                className="benefit"
                primary={"Downpayment starting at 49,999"}
              />
            </ListItem>
            <ListItem className="benefits-list">
              <ListItemAvatar className="avatar-benefit-list">
                <TaskAltRounded />
              </ListItemAvatar>
              <ListItemText
                className="benefit"
                primary={"Fastest processing"}
              />
            </ListItem>
            <ListItem className="benefits-list">
              <ListItemAvatar className="avatar-benefit-list">
                <TaskAltRounded />
              </ListItemAvatar>
              <ListItemText
                className="benefit"
                primary={"Completely refundable"}
              />
            </ListItem>
            <ListItem className="benefits-list">
              <ListItemAvatar className="avatar-benefit-list">
                <TaskAltRounded />
              </ListItemAvatar>
              <ListItemText
                className="benefit"
                primary={"3 years guaranteed buyback"}
              />
            </ListItem>
          </List>
        </Grid>
        <Grid sx={{ display: "block" }} item xs={12} md={6}>
          <LazyLoadImage
            src={imagesList.leadCaptureAutoBenefit}
            alt="piaggio-ape e-xtra-Euler-Hi-goods-vehicle"
            effect="opacity"
            width="100%"
          />
        </Grid>
      </Grid>
    </CustomBenefits>
  );
};
// export default LeadCaptureBenefits;

export const MemoizedLeadCaptureBenefits = React.memo(LeadCaptureBenefits);
